/**
* In this file contain the physician module Fliter UI and fliter logic
**/
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const FilterComponent = ({handleClinicChange,clinicList,handleSidebarToggle,handleDismiss,handleAgeChange}) => {
const role = Number(localStorage.getItem('role'));
const { t } = useTranslation();

	/**
	 * Intial variable declaration for age range fliter
	 **/
	const experienceFilter = [
      {value: {min: 0, max: 3}, text: `0-3 ${t('common.months')}`},
      {value: {min: 3, max: 6}, text: `3-6 ${t('common.months')}`},
      {value: {min: 6, max: 9}, text: `6-9 ${t('common.months')}`},
      {value: {min: 9, max: 12}, text: `9-12 ${t('common.months')}`},
      {value: {min: 1, max: 2}, text: `1-2 ${t('common.years')}`},
      {value: {min: 2, max: 3}, text: `2-3 ${t('common.years')}`},
      {value: {min: 3, max: 4}, text: `3-4 ${t('common.years')}`},
      {value: {min: 4, max: 5}, text: `4-5 ${t('common.years')}`}
    ];
 
  return (
    <div className="filter-container">
      {/* Side Filter Section */}
      <div className={`sideFilterbar ${role === 4 ? 'admin-sideFilterbar' : ''} ${handleSidebarToggle ? 'active' : ''}`}>
        <div className={`dismiss ${role === 4 ? 'admin-sideFilterbar-dismiss' : ''}`} onClick={handleDismiss}>
          <i className="fas fa-times"></i>
        </div>
		<Accordion defaultActiveKey={['0']} alwaysOpen  className="filter-card">
			{/*Age Section Fliter*/}
      <Accordion.Item eventKey="0">
        <Accordion.Header> <div className="head"> <h1>{t('table.age')}</h1> </div> </Accordion.Header>
        <Accordion.Body>
			<div className="body collapse multi-collapse show" >
			<ul>
			{experienceFilter && experienceFilter.map((item,i) => (
                <li key={i}>
                  <div className="custom-control custom-checkbox d-flex">
                    <input onChange={(e)=>handleAgeChange(e,item)} value={i+1} type="checkbox" className="custom-control-input" name="age_range" id={`ageRange__${i}`} />
                    <label className="custom-control-label text-capitalize" htmlFor={`ageRange__${i}`}>
                      {item?.text}
                    </label>
                  </div> 
                </li>
              ))}
			</ul>
		  </div>
        </Accordion.Body>
      </Accordion.Item>
	  {/*End Age Section Fliter*/}
	  
	  {/*Clinic Section Fliter*/}
    {role!==4 && 
          <Accordion.Item eventKey="1">
          <Accordion.Header> <div className="head"> <h1>{t('landing.clinics')}</h1> </div> </Accordion.Header>
          <Accordion.Body>
            <div className="body collapse multi-collapse show" id="collapseClinic">
              <ul>
                {clinicList && clinicList.data && clinicList.data.map((item) => (
                  <li key={item.id}>
                    <div className="custom-control custom-checkbox d-flex">
                      <input onChange={handleClinicChange} value={item.id} type="checkbox" className="custom-control-input" name="clinics" id={`customCheck__${item.id}`} />
                      <label className="custom-control-label text-capitalize" htmlFor={`customCheck__${item.id}`}>
                        {item?.name}
                      </label>
                    </div> 
                  </li>
                ))}
              </ul>
            </div>
          </Accordion.Body>
        </Accordion.Item>
    }
	  {/*End Clinic Section Fliter*/}
	  </Accordion>
        {/* Filter Card End */}
      </div>
    </div>
  );
};

export default FilterComponent;
